import { Subject } from "rxjs";
import { bucketBy } from "./bucketBy";
export function splitBy(predicate, subjectSelector = () => new Subject()) {
    return bucketBy(2, (value, index) => (predicate(value, index) ? 0 : 1), subjectSelector);
}
//# sourceMappingURL=splitBy.js.map